import {
    ADD_REDUX_MARKER,
    CLEAR_CURRENT_LAT_LNG,
    SELECT_DEALER,
    SET_ADDITIONAL_SERVICES,
    SET_BAC,
    SET_CURRENT_LAT_LNG,
    SET_DEALER_ENROLLMENT,
    SET_DEALER_FLAG,
    SET_DEALER_LOCATOR_RENDER_FLAG,
    SET_DEALER_SERVICES,
    SET_DEALER_SERVICES_FLAG,
    SET_DEALERS,
    SET_GOOGLE_MAPS_LOOKUP_ERROR,
    SET_REDUX_MARKERS,
    SET_SERVICE_OPTIONS,
} from "./ActionTypes";

const initialState = {
    //Boolean value to say if it's a dealer site or not
    isDealerSite: false,
    //selected dealer bac
    bac: 0,
    //Current Latitude Longitude: stores the coordinates that the Map will initialize as center and user's marker
    currentLatLng: null,
    //Array of dealerships returned from GetDealers backend call
    dealers: [],
    //Dealer services installation and additional services
    dealerServices: [],
    //Installation flag
    installation: 0,
    //enrolled dealer flag
    dealerEnrollment: false,
    //Dictionary of markers to allow dealer cards to be linked to the markers.
    markers: {},
    //Will only render list of dealers and map when set to true
    renderFlag: false,
    //Service flag to determine it should render or not
    dealerServicesFlag: false,
    //When the user confirms the dealer they would like it is saved here - same object as selected Marker
    selectedDealer: '',
    //Count for Show More
    showMoreCount: 0,
    //Dealer services
    serviceOptions: [],
    //Set Zoom Value to 16 when the user selected a dealership
    zoomValue: 0,
    //Google Geocoder Error
    googleMapsError: ''
};

const dealerReducer = (state = initialState, action) => {
    if (action.payload) {
        switch (action.type) {
            case SET_DEALER_FLAG: {
                return {
                    ...state,
                    isDealerSite: action.payload.dealerFlag
                }
            }
            case SET_BAC: {
                return Object.assign({}, state, {
                    newState: (state.bac = action.payload),
                });
            }
            case SET_CURRENT_LAT_LNG: {
                return Object.assign({}, state, {
                    newState: setCurrentLatLng(state, action),
                });
            }
            case CLEAR_CURRENT_LAT_LNG: {
                return Object.assign({}, state, {
                    newState: (state.currentLatLng = action.payload.position),
                });
            }
            case SET_DEALERS: {
                return {
                    ...state,
                    dealers: action.payload,
                };
            }
            case SET_DEALER_ENROLLMENT: {
                return Object.assign({}, state, {
                    newState: (state.dealerEnrollment = action.payload),
                });
            }
            case SET_DEALER_SERVICES: {
                return {
                    ...state,
                    dealerServices: action.payload,
                };
            }
            case SET_DEALER_SERVICES_FLAG: {
                return {
                    ...state,
                    dealerServicesFlag: action.payload.flag
                }
            }
            case SELECT_DEALER: {
                return Object.assign({}, state, {
                    newState: (state.selectedDealer = action.payload.dealerBAC),
                });
            }
            case SET_REDUX_MARKERS: {
                return {
                    ...state,
                    markers: action.payload,
                }
            }
            case SET_ADDITIONAL_SERVICES: {
                const selectOptions = [...state.serviceOptions];
                selectOptions[action.payload.serviceIndex].isChecked = !selectOptions[action.payload.serviceIndex].isChecked;
                return {
                    ...state,
                    serviceOptions: selectOptions
                }
            }
            case SET_SERVICE_OPTIONS: {
                return {
                    ...state,
                    serviceOptions: action.payload,
                };
            }
            case ADD_REDUX_MARKER: {
                return {
                    ...state,
                    markers: {
                        ...state.markers,
                        [action.payload.markerID]: action.payload.marker,
                    }
                }
            }
            case SET_GOOGLE_MAPS_LOOKUP_ERROR: {
                return {
                    ...state,
                    googleMapsError: action.payload.googleMapsError
                }
            }
            case SET_DEALER_LOCATOR_RENDER_FLAG: {
                return {
                    ...state,
                    renderFlag: action.payload.renderFlag
                }
            }
            default:
                return state;
        }
    } else {
        return state;
    }
};

const setCurrentLatLng = (state, action) => {
    if (action.payload) {
        //When coordinates provided by user
        if (action.payload.coords) {
            state.currentLatLng = {
                lat: action.payload.coords.latitude,
                lng: action.payload.coords.longitude,
            };
        } else {
            //When coordinates are determined with Zip
            state.currentLatLng = {
                lat: action.payload.lat,
                lng: action.payload.lng,
            };
        }
    }
    return state;
};

export default dealerReducer;

